import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
const icons = { FactCheckOutlinedIcon };

// ==============================|| MENU ITEMS - P2H INSPECTION ||============================== //

const p2hInspection = {
  id: 'p2hInspection',
  type: 'group',
  children: [
    {
      id: 'p2h-inspection',
      title: 'P2H Inspection',
      type: 'item',
      url: '/p2h',
      icon: icons.FactCheckOutlinedIcon
    }
  ]
};

export default p2hInspection;
